import { render, staticRenderFns } from "./SnippetVersionTimeline.vue?vue&type=template&id=b435b290&scoped=true&"
import script from "./SnippetVersionTimeline.vue?vue&type=script&lang=js&"
export * from "./SnippetVersionTimeline.vue?vue&type=script&lang=js&"
import style0 from "./SnippetVersionTimeline.vue?vue&type=style&index=0&id=b435b290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b435b290",
  null
  
)

export default component.exports